<script setup lang="ts">

</script>

<template>
  <div class="text-center pa-10">
    <div class="medium">Oops, This Page Could Not Be Found!</div>

    <div class="large">404</div>
  </div>
</template>

<style scoped lang="scss">

.medium {
  font-size: 24px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
}

.large {
  font-size: 10em;
  font-weight: bolder;
  color: #e4dfdf;

  @media (max-width: 768px) {
    font-size: 6em;
  }
}

</style>